import { Component, OnInit } from '@angular/core';
import { faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FullScreen, ScaleLine, Zoom, Attribution } from 'ol/control';
import { skip } from 'rxjs';
import { MapAbstractComponent } from '../../../shared/components/MapAbstractComponent';
import { GlobalVars } from '../../../shared/global-vars';
import { IPSData } from '../../../shared/models/ips-data';

@Component({
  selector: 'app-map-mobile',
  templateUrl: './map-mobile.component.html',
  styleUrl: './map-mobile.component.scss'
})
export class MapMobileComponent extends MapAbstractComponent implements OnInit {
  ultimatumId!: number;
  listPiezo!: IPSData[];
  faCross = faXmark;
  faSpinner = faCircleNotch;
  previousSelectedDate!: Date;
  layerType: string = GlobalVars.sectorLayersType.simplified;
  firstDateExecution = true;
  firstScenarioExecution = true;
  zoomControl!: Zoom;
  fullScreenControl!: FullScreen;

  ngOnInit(): void {
    this.sidebarService.setSidebarStatus(false);
    this.layerService.currentLayerState$.subscribe((layerState) => {
      this.sensorService.cancelRequests()
      this.updateLayersVisibility(layerState);
    });
    this.sidebarService.sidebarStatus$.subscribe(status => {
      if (!status && this.previousOverlay) {
        if (this.mapService.map) {
          this.mapService.map.removeOverlay(this.previousOverlay);
        }
        this.previousOverlay = null;
      }
    });

    this.mapService.createMap('map-mobile', [], this.refreshSector);

    this.initializeControls();

    if (this.mapService.map) {
      this.mapService.map.on('moveend', () => {
        if (this.mapService.map) {
          const currentZoom = this.mapService.map.getView().getZoom();
          if(currentZoom)
            this.mapService.updateZoomLevel(currentZoom);
          this.checkZoomAndFetchSensors(false);
          }
      });
    }

    this.sharedDateService.selectedDate$.subscribe((date: Date) => {
      this.previousSelectedDate = this.selectedDate;
      this.selectedDate = date;
      if (!this.firstDateExecution) {
        this.checkZoomAndFetchSensors(true);
      } else {
        this.firstDateExecution = false;
      }
    });
    this.sharedDateService.selectedScenario$.subscribe((scenario: string) => {
      this.selectedScenario = scenario;
      if (!this.firstScenarioExecution) {
        this.checkZoomAndFetchSensors();
      } else {
        this.firstScenarioExecution = false;
      }
    });
  
    this.mapService.zoomedRefresh$.pipe(skip(1)).subscribe((res) => {
      this.checkZoomAndFetchSensors(true);
    });

    this.authService.userInfoLoaded$.subscribe(isLoaded => {
      if (isLoaded) {
        this.checkZoomAndFetchSensors(false, true);
      }
    });
  }

  recreateControls(): void {
    if (this.mapService.map)
      this.mapService.map.removeControl(this.zoomControl);
  }

  initializeControls(): void {

    const scaleLineControl = new ScaleLine({
      className: 'custom-scale-line-control',
      units: 'metric',
    });
    
    const attributionControl = new Attribution();

    // Pour une raison obscure `this.mapService.map` peut être null d'après le compilateur
    // Solution de contournement : double vérification de l'obj
    if (this.mapService.map)
      this.mapService.map.addControl(scaleLineControl);
    if (this.mapService.map)
      this.mapService.map.addControl(attributionControl);
  }
}
